import { Layout } from 'antd';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import Bottombar from './Bottombar';
import { Outlet } from 'react-router-dom';
import { useState } from 'react';

const { Content } = Layout;

const Main = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <Sidebar 
        collapsed={sidebarCollapsed} 
        onCollapseChange={setSidebarCollapsed} 
      />
      {/* Main content area with dynamic left margin based on sidebar state */}
      <div 
        className={`flex-1 flex flex-col transition-all duration-300 pt-16 ${
          sidebarCollapsed ? 'ml-20' : 'ml-[280px]'
        }`}
      >
        <Content className="flex-1 px-10 py-8 min-h-screen bg-gray-50">
          <Outlet />
        </Content>
        <Bottombar />
      </div>
    </div>
  );
};

export default Main;